// React
import { isMobile } from 'react-device-detect';
import { BasePageContainer } from './styles';

interface BasePageProps {
  text: string;
}

export const BasePage = ({text}: BasePageProps) => {
  return (
    <BasePageContainer isMobile={isMobile}>
      <img alt="No menu item selected" src="defaultCommunication.svg" />
      <h3>{text}</h3>
    </BasePageContainer>
  )
}